import React, { Component } from "react";
import { Form, Button, Modal, Divider } from "antd";
import { connect } from "dva";
import { ENV } from "@/services/utils";
import FormCreate from "@/components/FormCreate/index";
import styles from "./EvaluationForm.less";

const { Item } = Form;
const { confirm } = Modal;
const {
  FormTextArea,
  FormInputNumber,
  FileUpload,
  FormRadioGroup
} = FormCreate;
const radioGroupProps = [
  {
    label: "通过",
    value: 1
  },
  {
    label: "驳回",
    value: 0
  }
];

@Form.create()
@connect(({ evaluation }) => ({
  index: evaluation.index
}))
class EvaluationForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      newAppendix: null
    };
  }

  componentDidMount = () => {
    const { onRef } = this.props;
    if (onRef) {
      onRef(this);
    }
  };

  handleSubmit = () => {
    const { newAppendix } = this.state;
    const {
      dispatch,
      form,
      projectId,
      indexId,
      targetOrgId,
      groupId,
      orgName,
      update,
      callback,
      templateType,
      org
    } = this.props;

    const { validateFields } = form;

    validateFields((err, data) => {
      const { score, remark, wetherRealPatrol, approved } = data;
      if (!err) {
        dispatch({
          type: "evaluation/submitAddReport",
          payload: {
            type: templateType, // 模版类型
            approved,
            indexId,
            projectId,
            targetOrgId,
            targetOrgName: orgName,
            groupId,
            score: Number(score) || 0,
            remark,
            appendix: newAppendix,
            wetherRealPatrol: wetherRealPatrol ? 1 : 0,
            org: org || false
          },
          callback: () => {
            callback();
            update(false);
          }
        });
      }
    });
  };

  onReset = () => {
    const { form } = this.props;
    form.resetFields();
  };

  handleFileGroupId = fileId => {
    this.setState({
      newAppendix: fileId
    });
  };

  handleBack = () => {
    const { newAppendix } = this.state;
    const { goBack, form } = this.props;
    const { getFieldsValue } = form;
    const values = getFieldsValue();
    const { score, remark, wetherRealPatrol } = values;
    if (score || remark || wetherRealPatrol || newAppendix) {
      confirm({
        title: `提示`,
        content: "您有填写的内容，返回将不会自动保存，仍要继续返回吗",
        okText: "确定",
        cancelText: "取消",
        onOk: () => {
          goBack();
        }
      });
    } else {
      goBack();
    }
  };

  render() {
    const {
      form,
      score,
      remark,
      appendix,
      approved,
      index,
      templateType = 1,
      reRender
    } = this.props;

    const tailFormItemLayout = {
      wrapperCol: {
        sm: {
          span: 12,
          offset: 3
        }
      }
    };

    const evaluationScoreProps = {
      form,
      value: score || 0,
      label: "评估分数",
      keyName: "score",
      isRequired: true,
      step: 0.1,
      precision:2,
      max: Number(index.score),
    };

    const evaluationRemarkProps = {
      form,
      value: remark,
      label: "评估说明",
      keyName: "remark",
      rows: 5,
      myselfRules: [
        {
          max: 1000,
          message: "评估说明不能超过1000字"
        }
      ]
    };

    const evaluationApprovedProps = {
      form,
      value: approved,
      label: "审核状态",
      keyName: "approved",
      RadioGroupOptions: radioGroupProps,
      isRequired: true
    };

    const evaluationExamineProps = {
      form,
      value: remark,
      label: "审核说明",
      keyName: "remark",
      maxLength: 1000,
      rows: 5,
      isRequired: false
    };

    const evaluationFileProps = {
      form,
      groupId: appendix,
      edit: 0,
      APIEnv: ENV,
      type: "pc",
      handleFileGroupId: this.handleFileGroupId,
      key: appendix
      // fileCount: filesNumber
    };

    return (
      <div className={styles.evaluationForm}>
        <div className="evaluationDetailTitle">
          <Divider orientation="left">专家评估</Divider>
        </div>
        {reRender && (
          <FormCreate>
            {(templateType === 1 || templateType === 2) && (
              <FormInputNumber {...evaluationScoreProps} />
            )}
            {(templateType === 1 || templateType === 2) && (
              <FormTextArea {...evaluationRemarkProps} />
            )}
            {templateType === 3 && (
              <FormRadioGroup {...evaluationApprovedProps} />
            )}
            {templateType === 3 && <FormTextArea {...evaluationExamineProps} />}
            {(templateType === 1 || templateType === 2) && (
              <FileUpload {...evaluationFileProps} />
            )}
            {/* {templateType === 2 && (
                <Item {...tailFormItemLayout}>
                  {getFieldDecorator("wetherRealPatrol", {
                    initialValue: !!wetherRealPatrol,
                    valuePropName: "checked"
                  })(<Checkbox>建议实地核查</Checkbox>)}
                </Item>
              )} */}
            <Item {...tailFormItemLayout}>
              <Button
                size="default"
                type="primary"
                style={{ marginRight: 8 }}
                onClick={this.handleSubmit}
              >
                审核评价
              </Button>
              <Button onClick={this.handleBack}>返回</Button>
            </Item>
          </FormCreate>
        )}
      </div>
    );
  }
}

export default EvaluationForm;
